import Access_Logs from './components/Access_Logs';

export default Access_Logs;
